import React, { useState } from "react";
import ctl from "@netlify/classnames-template-literals";
import { Pagination } from "react-headless-pagination";

import { GetMoreStoriesPane } from "./get-more-stories-pane";

import { Container, Ntext } from "components";
import { BlogTopPost } from "./top-post";
import { BlogCategoryFilter } from "./category-filter";
import { BlogPostCard } from "./post-card";
import { BlogPostCardSkeleton } from "./post-card-skeleton";

const BlogArticles = ({ state, dispatch }) => {
  const handlePageChange = page => {
    dispatch({ type: "update-page", payload: page });
  };

  const skeleton_data = Array(11)
    .fill(1)
    .map((_, i) => i);

  return (
    <section>
      <section className="px-[100px]">
        <BlogTopPost state={state} />
        <div className="mt-16 md:max-w-[1335px] mx-auto">
          <Ntext
            variant="h1"
            className="!text-[48px] !leading-[56px] !tracking-[-2px] !font-normal mb-2"
          >
            Our Blogs
          </Ntext>
          <Ntext
            variant="h1"
            className="!text-[20px] !leading-[32px] !tracking-[-0.8px] !font-medium !text-[#808080] "
          >
            Here, we share financial tips, product updates, case studies and
            stories that inspires your payments and career lifetyles.
          </Ntext>
        </div>
        <div className="w-full mt-12 mb-16 md:max-w-[1335px] mx-auto">
          <BlogCategoryFilter state={state} dispatch={dispatch} />
        </div>
        <div className="grid grid-cols-6 h-fit gap-x-6 gap-y-16 mb-16 md:max-w-[1335px] mx-auto">
          {state?.articles_loading ? (
            <>
              {skeleton_data.slice(0, 2).map(item => (
                <BlogPostCardSkeleton key={item} colums={3} />
              ))}
              {skeleton_data.slice(2).map(item => (
                <BlogPostCardSkeleton key={item} colums={2} />
              ))}
            </>
          ) : (
            <>
              {state?.articles?.slice(0, 2).map(article => (
                <BlogPostCard key={article?.id} colums={3} article={article} />
              ))}
              {state?.articles?.slice(2).map(article => (
                <BlogPostCard key={article?.id} colums={2} article={article} />
              ))}
            </>
          )}
        </div>
        {state.total_pages ? (
          <Pagination
            className="flex justify-between w-full md:max-w-[1335px] mx-auto"
            currentPage={state.page}
            edgePageCount={2}
            middlePagesSiblingCount={1}
            setCurrentPage={handlePageChange}
            totalPages={state.total_pages | 0}
            truncableClassName="w-10 px-0.5 text-center"
            truncableText="..."
          >
            <nav className="flex justify-center gap-1">
              <ul className="flex items-center">
                <Pagination.PageButton
                  activeClassName="text-[#0D0D0D] bg-[#F2F2F2] "
                  inactiveClassName="text-[#808080]"
                  className="text-[24px] leading-[32px] tracking-[-0.8px] font-medium w-16 h-16 flex items-center justify-center rounded-2xl cursor-pointer "
                />
              </ul>
            </nav>
            <nav className="flex items-center gap-6">
              <div
                className={`h-14 w-14 rounded-full flex items-center justify-center ${
                  state.page > 0 ? "bg-[#FFD633]" : "bg-[#999999] opacity-30"
                }`}
                onClick={() => {
                  if (state.page === 0) return;
                  handlePageChange(state.page - 1);
                }}
                role="button"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.647 20.0485C11.1783 20.5172 10.4185 20.5172 9.94991 20.0485L2.74991 12.8485C2.28128 12.3799 2.28128 11.6201 2.74991 11.1515L9.94991 3.95147C10.4185 3.48284 11.1783 3.48284 11.647 3.95147C12.1156 4.4201 12.1156 5.17989 11.647 5.64852L6.49549 10.8L20.3984 10.8C21.0612 10.8 21.5984 11.3373 21.5984 12C21.5984 12.6627 21.0612 13.2 20.3984 13.2L6.49549 13.2L11.647 18.3515C12.1156 18.8201 12.1156 19.5799 11.647 20.0485Z"
                    fill="#0d0d0d"
                  />
                </svg>
              </div>
              <div
                className={`h-14 w-14 rounded-full flex items-center justify-center ${
                  state.page < (state.total_pages - 1 || 0)
                    ? "bg-[#FFD633]"
                    : "bg-[#999999] opacity-30"
                }`}
                onClick={() => {
                  if (state.page === 49) return;
                  handlePageChange(state.page + 1);
                }}
                role="button"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.353 20.0485C12.8217 20.5172 13.5815 20.5172 14.0501 20.0485L21.2501 12.8485C21.7187 12.3799 21.7187 11.6201 21.2501 11.1515L14.0501 3.95147C13.5815 3.48284 12.8217 3.48284 12.353 3.95147C11.8844 4.4201 11.8844 5.17989 12.353 5.64852L17.5045 10.8L3.60156 10.8C2.93882 10.8 2.40156 11.3373 2.40156 12C2.40156 12.6627 2.93882 13.2 3.60156 13.2L17.5045 13.2L12.353 18.3515C11.8844 18.8201 11.8844 19.5799 12.353 20.0485Z"
                    fill="#0D0D0D"
                  />
                </svg>
              </div>
            </nav>
          </Pagination>
        ) : null}
      </section>

      <section className="mt-[96px] py-[96px] px-[100px] bg-[#F2F2F2] border-t border-[#CCCCCC]">
        <GetMoreStoriesPane />
      </section>
    </section>
  );
};

export { BlogArticles };
